// Import global styles
import '@/assets/scss/main.scss'
import 'vue-porg/dist/app.vue-porg.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import PorgPlugin from 'vue-porg'
import store from './store'
import { mapState } from 'vuex'
import client from '@/api/client'

Vue.config.productionTip = false

Vue.use(PorgPlugin, {
  router: router,
  store: store,
  axios: client,
  default2FAChallenge: 'U2FChallenge'
})

Vue.mixin({

})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  computed: {
    ...mapState(['loggedUser'])
  },
  methods: {},
  render (createElement) {
    return createElement(App, {})
  }
})

/* eslint-enable no-new */
